
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer,resetArrays } from "../../redux/MultiselectRows"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { useEditPatientMutation,  useExportPatientsMutation, useGetPatientsQuery } from "../../slices/patientSlice"
import { handleAddFilterValues ,handleIsUserScreen} from "../../redux/systemConfigSlice"
import { setPatientSearch,resetPatientSearch, setPatSearchApplied } from "../../redux/patientSearchSlice";


import PatientTable from "./Component"
import moment from "moment"
import {convertDatesToEpochUTC} from '../../CommonMethods/ConvertFilterDatetoEpochUtcFormat'
import TopBarPatient from "./TopBar"
import PatiantAdvancedSearch from "./Component/AdvancedSearch"

export default function ManageDashboardPatients(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar, setIsSearchOpen, isSearchOpen} = useContext(GlobalContext);
    
    const [editPatient]=useEditPatientMutation()
    const [exportPatientList]=useExportPatientsMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const auth=useSelector(state=>state?.auth)
    const orgId=useSelector(state=>state?.systemConfigData?.organization_id)
    const filtervals = useSelector(state=>state?.systemConfigData?.filterState)
    const patientSearch = useSelector(state => state.patientSearchData);
    const searchApplied = useSelector((state) => state.patientSearchData.patsearchApplied);


    const {userType} = auth
    const initialState={
        "start_date":'',
        "end_date":'',
        // "organization_id":"",
        'organization_name':'',
    }
    const [filterValues,setFilterValues]=useState(initialState)
    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const {data,isFetching,isLoading,status}=useGetPatientsQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
        
        if(location.state!==null&&location.state!==''&&location?.state?.limit!==undefined&& !Array.isArray(location.state)){
            let params={};
            if(location?.state?.search!==''){
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                    'search':decodeURIComponent(location.state.search)
                }
            }else{
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                }

            }
            setSearchParams({...params})
            
        }
        else{
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
           
            }
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('sort')) {
                handleSearchParams('sort', `created_at+desc`)
            }
            // if(!searchParams.get('filter')) {
            //     handleSearchParams('filter', `true`)
            // }
        }
        
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=3){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }

    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    useEffect(()=>{
        if(searchParams?.get("organization_name")!==null&&filtervals?.organization_name!==undefined){
            setSelectedOrganizationName([{
                organization_name:filtervals['organization_name'] ,
                // organization_id: filtervals['organization_id'],
            }]) 
        }
    },[])

    const handleChange = (val) => {
        handleSearchParams('search', val)
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        const start_date = filterValues?.start_date ? moment(filterValues?.start_date).format('YYYY-MM-DD') : null;        
        const end_date = filterValues?.end_date ? moment(filterValues?.end_date).format('YYYY-MM-DD') : null;
        if (type) {
            // params.filter = "true";
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                "start_date":start_date,
                "end_date":end_date,
                // "organization_id":filterValues.organization_id,
                'organization_name':filterValues.organization_name,
            }));

            params.page_number=1
            filterValues?.organization_name!==""&&filterValues?.organization_name!==undefined?params["organization_name"]=filterValues.organization_name:''
            filterValues?.start_date!==""&&filterValues?.start_date!==undefined?params["start_date"]=convertDatesToEpochUTC(start_date,Intl.DateTimeFormat().resolvedOptions().timeZone,true):''
            filterValues?.end_date!==""&&filterValues?.end_date!==undefined?params["end_date"]=convertDatesToEpochUTC(end_date,Intl.DateTimeFormat().resolvedOptions().timeZone,false):''
            params.filter = "true";
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                "start_date":'',
                "end_date":'',
                "organization_name":"",
            });
    
            // Remove filter-related keys from searchParams
            
            // delete params['filter'];
            params["organization_name"]&& delete params["organization_name"]
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            if (params["filter"] === "true") {
                delete params["filter"];
            }
            setSearchParams({ ...params });
        }
    };
    
    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        
        if((confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""&&confirmationState?.rowData?.status === 'active' && textAreaMsg.trim()=== '')||(confirmationState?.multirow==="deactive"&&(textAreaMsg.trim()===''))){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = { }
            if(confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""){
                {confirmationState?.rowData?.status === 'inactive' ?
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : ''
                    } : 
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : textAreaMsg 
                    } 
                }
            }
            else{
                confirmationState?.multirow==="deactive"?
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : textAreaMsg 
                    }
                    :
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : ''
                        
                    }
            }
            setLoading(true)
            
            const activationRes=await editPatient({body})
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage('Something went wrong. Please try again')
            }else{
                if(confirmationState?.multirow!==""&&confirmationState?.multirow!==undefined){
                    setToastmessage(`Patients ${confirmationState?.multirow==="active"?"activated":"deactivated"} successfully`);
                }
                else{
                    setToastmessage(`Patient ${confirmationState?.rowData?.status==="inactive"?"activated":"deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    } 
    const handleOnSubmit = (e) => {
        setisSortSelected(false);
        e.preventDefault();
    
        let searchString = '';
    
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };
    
        // Function to handle common field logic
        const handleField = (field, fieldName, inverseField) => {
            if (patientSearch?.[field] && patientSearch[field].trim() !== '') {
                const prefix = patientSearch[inverseField] ? 'ne:' : '';
                const formattedValue = formatSearchValue(patientSearch[field]);
                searchString += `${fieldName}=${prefix}${encodeURIComponent(formattedValue)};`;
            }
        };
    
        // Use a switch statement to handle each field
        const fields = Object.keys(patientSearch || {});
        fields.forEach(field => {
            switch (field) {
            case 'user_id':
                handleField('user_id', 'patient_id', 'user_id_inverse');
                break;
            case 'first_name':
                handleField('first_name', 'first_name', 'first_name_inverse');
                break;
            case 'middle_name':
                handleField('middle_name', 'middle_name', 'middle_name_inverse');
                break;
            case 'last_name':
                handleField('last_name', 'last_name', 'last_name_inverse');
                break;
            case 'age':
                handleField('age', 'patient_dynamic_age', 'age_inverse');
                break;
            case 'primary_identifier':
                handleField('primary_identifier', 'primary_identifier', 'primary_identifier_inverse');
                break;
            case 'secondary_identifier':
                handleField('secondary_identifier', 'secondary_identifier', 'secondary_identifier_inverse');
                break;
            case 'sub_division_name':
                handleField('sub_division_name', 'subdivision_name', 'sub_division_name_inverse');
                break;
            case 'user_name':
                if (patientSearch?.user_name || patientSearch.user_name_domain) {
                    const userNamePrefix = patientSearch.user_name_inverse ? 'ne:' : '';
                    const userName = formatSearchValue(patientSearch.user_name || '');
                    const userNameDomain = formatSearchValue(patientSearch.user_name_domain || '');
                    searchString += `user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
                }
                break;
            case 'email_address':
                if (patientSearch?.email_address || patientSearch.email_address_domain) {
                    const emailAddressPrefix = patientSearch.email_address_inverse ? 'ne:' : '';
                    const emailAddress = formatSearchValue(patientSearch.email_address || '');
                    const emailAddressDomain = formatSearchValue(patientSearch.email_address_domain || '');
                    searchString += `email_address=${emailAddressPrefix}${encodeURIComponent(emailAddress)}@${encodeURIComponent(emailAddressDomain)};`;
                }
                break;
            default:
                // Handle other fields or ignore
                break;
            }
        });
    
        // Handle `status` with optional inverse condition
        if (Array.isArray(patientSearch.status)) {
            const userStsPrefix = patientSearch.status_inverse ? 'ne:' : '';
            patientSearch.status.forEach(type => {
                searchString += `status=${userStsPrefix}${encodeURIComponent(type)};`;
            });
        }
    
        const { dob_day, dob_month, dob_year } = patientSearch || {};
    
        // Check if only some of the fields are filled
        const isPartialDateFilled =
            (dob_day && (!dob_month || !dob_year)) ||
            (dob_month && (!dob_day || !dob_year)) ||
            (dob_year && (!dob_day || !dob_month));
    
        if (isPartialDateFilled) {
            setEmptyField(true);
            return;
        } else if (dob_day && dob_month && dob_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${dob_year}-${String(dob_month).padStart(2, '0')}-${String(dob_day).padStart(2, '0')}`;
    
            const dobDatePrefix = patientSearch.dob_inverse ? 'ne:' : '';
    
            // Add epoch to search string
            searchString += `date_of_birth=${dobDatePrefix}${encodeURIComponent(dateStr)};`;
        }
    
        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
    
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: patientSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setPatSearchApplied());
    };

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Patients"}/>
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarPatient 
                            title={'List of Patients'}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Patient"}
                            menuBar={(data!==undefined&&data?.data?.length>0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-patients/add-patients'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','First Name','Middle Name','Last Name','Date of Birth','Age','Status','Organization Name','Sub Division Name','Primary Identifier','Secondary Identifier','Email Address','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportPatient={exportPatientList}
                            filterValues={filterValues}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setFilterValues={setFilterValues}
                            handleApplyFilter={handleApplyFilter}
                            TotalCount={parseInt(data?.total_count)}
                            // isIdexport={true}
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Patient's list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <PatientTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}

                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-full px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false") || (searchParams.get('start_date')!==null||searchParams.get('end_date')!==null||searchParams.get('organization_name')!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Patients"}
                                FirstPTag={"No Patients associated yet ."}
                               
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                disabled={loading}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want to ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} the patient?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following patients?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }
                {isSearchOpen &&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <PatiantAdvancedSearch emptyField={emptyField} setEmptyField={setEmptyField} handleOnSubmit={handleOnSubmit}
                />}
            </div>
        </>
    )
}